module.exports = __webpack_public_path__ + "img/komplettbank.6234db2.png";